import {ApiFormData} from "@lib/form-data";
import {EntryInitialLoadResponse, UploadResponse} from "../types/response";
import {EntryVars} from "@pages/entry/modules/functions";

export type SaveParams = {
    company_name: string;
    your_name: string;
    email: string;
    tel: string;
    project_detail_section: string;
    project_detail_section_other_text: string;
    yoto_naiyo1: string;
    yoto_menseki1: string;
    shinsakikan_sinseitaio: string;
    mitsumori_iraijino_kibonoki: string;
    files:string;
}

export class EntryRepository {

    private readonly url: string;
    private readonly secure: string;
    private action: string = 'entry'

    constructor(entryVars: EntryVars) {
        this.secure = entryVars.secure;
        this.url = entryVars.endpoint;
    }

    async initialLoad(): Promise<EntryInitialLoadResponse> {

        let payload = {
            action: this.action,
            mode: 'INITIAL_LOAD',
            secure: this.secure,
        }
        const debug = new URLSearchParams(window.location.search).has('debug');
        if(debug){
            payload['debug'] = 1;
        }

        const apiClient = ApiFormData.createWithFields(payload);
        return await apiClient.post<EntryInitialLoadResponse>(this.url);
    }

    async upload(files: File[]): Promise<UploadResponse> {
        const apiClient = ApiFormData.createWithFields({
            action: this.action,
            mode: 'UPLOAD',
            secure: this.secure,
        });
        files.forEach(file => apiClient.appendFile('attachment[]', file));
        return await apiClient.post<UploadResponse>(this.url, {timeout: 120000});
    }


    async save(params:SaveParams): Promise<UploadResponse> {
        const apiClient = ApiFormData.createWithFields({
            action: this.action,
            mode: 'SAVE',
            secure: this.secure,
            data: JSON.stringify(params),
        });
        return await apiClient.post<UploadResponse>(this.url);
    }
}
